import m from "crypto-js/md5.js";
import b from "axios";
import g from "js-cookie";
function y() {
  return typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Function("return this")();
}
function h() {
  return typeof global != "object" || !global || global.Math !== Math || global.Array !== Array ? y() : global;
}
const E = (u) => {
  try {
    if (!u || !u.length)
      return;
    const e = u.reduce((t, { experimentUrls: s, variableName: r, variableValue: i }) => (s && s.length && s.forEach((n) => {
      t[n] || (t[n] = { variable: {}, sign: "" }), t[n].variable[r] = i;
    }), t), {});
    return Object.keys(e).forEach((t) => {
      e[t].sign = window.btoa(JSON.stringify(e[t].variable));
    }), e;
  } catch {
  }
}, k = "ABTEST_KEY_SIGN", p = "x-ab-test-id", _ = {
  CHINA: "https://abtest-proxy.hlgdata.com/v2/strategy",
  USE: "https://abtest-proxy.insmind.com/v2/strategy"
}, f = 60 * 30 * 1e3, c = {
  app_key: [
    { require: !0, message: "parameter app_key is not present" },
    { empty: !1, message: "parameter app_key cannot be empty" }
  ],
  app_name: [
    { require: !0, message: "parameter app_name is not present" },
    { empty: !1, message: "parameter app_name cannot be empty" }
  ],
  user_id: [
    { require: !0, message: "parameter user_id is not present" },
    { empty: !0, message: "parameter user_id cannot be empty" }
  ],
  device_id: [
    { require: !0, message: "parameter device_id is not present" },
    { empty: !1, message: "parameter device_id cannot be empty" }
  ],
  is_login: [
    { require: !1, message: "parameter is_login is not present" },
    // 允许 is_login 为空不传，该字段为保留字段暂时无用
    // {empty: false, message: 'parameter is_login cannot be empty'}
    { empty: !0, message: "parameter is_login cannot be empty" }
  ],
  org_id: [
    { require: !0, message: 'org_id 租户必填，如果不存在 org_id，可填写字符串 "0"' },
    // 租户 id 必填
    { empty: !1, message: 'org_id 租户必填，如果不存在 org_id，可填写字符串 "0"' }
    // 允许为空字符串
  ]
};
class x {
  constructor() {
    this.apiUrl = "", this.option = null, this.hooks = {}, this._requestInstance = null;
  }
  /**
   * 初始化
   * @param {Object} option
   * eg
   * gdABTestSdk.init({
   *   app_key: 'xxxxx', //应用对应的 appKey，必填
   *   app_name: 'xxxxx', // 应用对应的 appName，必填
   *   user_id:  'xxxxx', // 客户端能唯一标识用户的ID，必填
   *   device_id: 'xxxxx', // 设备ID，必填
   *   is_login: 'xxxx', // 是否登录，非必填
   *   org_id: 'xxxx' // 租户 id 非必填
   *   env: 'dev','fat','stage','prod' // 环境变量
   * })
   */
  init(e) {
    this._optionValidator(e) && (this.option = e, this.apiUrl = _[e.region] || _.CHINA);
  }
  /**
   * 根据 eventId 获取 abtags  同步
   * @param {array} eventId
   */
  getSyncAbTags(e) {
    return this.takeAbtags(e);
  }
  /**
   * 根据 eventId 获取 abtags  异步
   * @param {array} eventId
   */
  getAsyncAbTags(e) {
    return new Promise((t) => {
      const s = this.takeAbtags(e);
      if (!s) {
        this.on("fetch", () => {
          const r = this.takeAbtags(e);
          t(r);
        }), setTimeout(() => {
          const r = this.takeAbtags(e);
          t(r);
        }, 2e3);
        return;
      }
      t(s);
    });
  }
  /**
   * 根据 eventId 获取 abtags
   * @param {array} eventId
   */
  getAbTags(e) {
    return new Promise((t) => {
      const s = this.takeAbtags(e);
      if (!s) {
        this.on("fetch", () => {
          const r = this.takeAbtags(e);
          t(r);
        }), setTimeout(() => {
          const r = this.takeAbtags(e);
          t(r);
        }, 2e3);
        return;
      }
      t(s);
    });
  }
  /**
   * 获取本地策略
   * @param {*} eventId
   */
  takeAbtags(e) {
    const t = this._getMatchedExps(!1);
    if (!t)
      return null;
    const r = t.filter((i) => i.eventIds.includes(e)).map((i) => `${i.experimentId}_${i.versionId}`);
    return r.length === 0 ? null : r;
  }
  /**
   * 根据变量名称获取所匹配的版本信息的变量值
   * @param {string} variableName 变量名
   * @param {any} defaultVaule 无匹配值时返回默认值，默认 ‘’
   */
  getValue(e, t) {
    if (typeof e == "string")
      return this._getSingleValue(e, t);
    if (Array.isArray(e))
      return Array.isArray(t) ? this._getMultipleValue(e, t) : "defaultVaule should be an array";
  }
  /**
   * 根据变量名称获取所匹配的实验标识
   * @param {string} variableName 变量名
   * @returns 'abtag' | null
   */
  getTag(e) {
    return this._getSingleTag(e);
  }
  /**
   * 设置 userId
   * @param {string|int} userId 用户id
   */
  setUserId(e) {
    return new Promise((t, s) => {
      this.option ? t() : s(new Error("Please initialize sdk first"));
    }).then(() => {
      if (e !== this.option.user_id)
        return this.option.user_id = e, this._clearMatchedExps(), this.getExps();
    }).catch((t) => {
      console.error(t);
    });
  }
  /**
   * 设置 deviceId
   * @param {string|int} deviceId 设备 id
   */
  setDeviceId(e) {
    return new Promise((t, s) => {
      this.option ? t() : s(new Error("Please initialize sdk first"));
    }).then(() => {
      if (e !== this.option.device_id)
        return this.option.device_id = e, this._clearMatchedExps(), this.getExps();
    }).catch((t) => {
      console.error(t);
    });
  }
  /**
   * 设置 orgId
   * @param {string|int} orgId 租户id
   */
  setOrgId(e) {
    return new Promise((t, s) => {
      this.option ? t() : s(new Error("Please initialize sdk first"));
    }).then(() => {
      if (e !== this.option.org_id)
        return this.option.org_id = e, this._clearMatchedExps(), this.getExps();
    }).catch((t) => {
      console.error(t);
    });
  }
  /**
   * 注册监听事件 (返回一个用于取消监听的函数)
   * eg
   * const cancel = window.gdABTest.on('fetch', (reault) =>{
   *   console.log('--fetch---', reault);
   * })
   * @param {string} name
   * @param {function} callback
   * @returns {function} cancel
   */
  on(e, t) {
    return this.hooks[e] || (this.hooks[e] = []), this.hooks[e].push(t), this.off.bind(this, e, t);
  }
  /**
   * 取消注册的监听事件
   * eg
   * const callback = (reault) => {
   *  console.log('--fetch---', reault);
   * };
   * // 1. 注册监听事件
   * window.gdABTest.on('fetch', callback)
   * // 2. 取消监听事件
   * window.gdABTest.off('fetch', callback)
   * @param {string} name
   * @param {function} callback
   */
  off(e, t) {
    if (!Array.isArray(this.hooks[e])) return;
    const s = this.hooks[e].filter((r) => r !== t);
    this.hooks[e] = s;
  }
  /**
   * 运行 fetch事件
   * @param {array} data
   */
  runFetchHook(e) {
    this.hooks.fetch && this.hooks.fetch.forEach((t) => {
      t(e || []);
    });
  }
  /**
   * 运行 埋点事件
   * @param {object} data
   * @deprecated 该方法已经弃用，不再上报 abtest_track 埋点事件
   */
  runWindTrackHook(e) {
  }
  /**
   * 获取所有匹配的版本信息
   * @param {function} callback 回调函数
   */
  getExps() {
    return new Promise((e) => {
      const t = this._getMatchedExps();
      e(t);
    }).then((e) => e || (this._requestInstance ? this._requestInstance : (this._requestInstance = this._requestExps(), this._requestInstance))).then((e) => e);
  }
  /**
   * 获取缓存策略
   */
  getCache() {
    return this._getMatchedExps();
  }
  _getMatchedExps(e = !0) {
    const { app_key: t } = this.option || {}, s = h();
    if (s.localStorage && s.localStorage.getItem(t)) {
      const r = JSON.parse(s.localStorage.getItem(t)) || {}, i = r.params;
      return this._isCacheValid(i, r, e) ? r.data : (this._requestInstance = null, null);
    }
    return null;
  }
  _isCacheValid(e, t, s) {
    if (!e)
      return !1;
    const { device_id: r, user_id: i, org_id: n, env: a } = this.option || {}, o = g.get(`${p}.${a}`);
    return o && e.ab_test_id === o ? !0 : e.device_id !== r || e.user_id !== i || e.org_id !== n || o && e.ab_test_id !== o ? !1 : s ? (/* @__PURE__ */ new Date()).getTime() - t.timestamp < f : !0;
  }
  _setMatchedExps(e, t) {
    const { app_key: s, env: r } = this.option || {}, i = h();
    if (i.localStorage) {
      const n = g.get(`${p}.${r}`), a = E(e);
      if (i.localStorage.setItem(s, JSON.stringify({
        timestamp: (/* @__PURE__ */ new Date()).getTime(),
        abtestLifeTime: f,
        params: Object.assign(t, { ab_test_id: n }),
        data: e,
        experimentSign: a
      })), i.CustomEvent) {
        const o = new CustomEvent("GD_CUSTOM_EVENT_AB_MODIFY", { detail: { key: s } });
        i.dispatchEvent(o);
      }
    }
  }
  _clearMatchedExps() {
    const { app_key: e } = this.option || {}, t = h();
    t.localStorage && t.localStorage.removeItem(e);
  }
  /**
   * 获取单个变量名对应的变量值
   * @param {string} variableName 变量名
   * @param {string} defaultVaule 默认值
   */
  _getSingleValue(e, t = "") {
    return this.getExps().then((s) => {
      const r = s.filter((i) => i.variableName === e);
      return r[0] && r[0].variableValue ? r[0].variableValue : t;
    }).catch(() => t);
  }
  /**
   * 获取实验标识
   * @param {string} variableName 变量名
   */
  _getSingleTag(e) {
    return this.getExps().then((t) => {
      const s = t.find((r) => r.variableName === e);
      return s ? `${s.experimentId}_${s.versionId}` : null;
    }).catch(() => null);
  }
  /**
   * 获取多个变量名对应的变量值
   * @param {array} variableName 变量名
   * @param {array} defaultVaule 默认值
   */
  _getMultipleValue(e, t = []) {
    return this.getExps().then((s) => e.map((n) => s.find((a) => n === a.variableName)).map((n, a) => n ? n.variableValue : t[a] || "")).catch(() => t);
  }
  /**
   * 私有方法，请求版本信息
   * @return Promise|null
   */
  _requestExps() {
    if (typeof window < "u" && window._IS_PRIVATE_)
      return [];
    if (!this.option) {
      console.error("please initialize sdk first");
      return;
    }
    const { app_key: e, app_name: t, user_id: s, device_id: r, is_login: i, org_id: n } = this.option, a = m(e + r + k).toString().toUpperCase(), o = {
      user_id: s,
      device_id: r,
      is_login: i,
      org_id: n
    };
    return b.get(`${this.apiUrl}/${t}`, {
      params: o,
      headers: { "ABTEST-SIGN": a }
    }).then((l) => {
      this._setMatchedExps(l.data, o), this.runFetchHook(l.data);
      const d = setTimeout(() => {
        this._requestInstance = null, clearTimeout(d);
      }, 1e3 * 60);
      return l.data;
    }).catch((l) => {
      console.log(l);
    });
  }
  _optionValidator(e) {
    for (const t in c) {
      if (c[t][0].require && e[t] === void 0)
        return console.error(c[t][0].message), !1;
      if (!c[t][1].empty && !e[t])
        return console.error(c[t][1].message), !1;
    }
    return !0;
  }
}
const I = new x();
export {
  I as default
};
